// extracted by mini-css-extract-plugin
module.exports = {"root":"Badges_root__tce5g"};